export const isAbsoluteUrl = (value = "") =>
  /^(?:[a-z]+:)?\/\//i.test(value) || value.startsWith("mailto:") || value.startsWith("tel:");

export const normalizePathWithTrailingSlash = (value = "/") => {
  if (!value || value === "/") return "/";

  const [pathAndQuery = "", hash = ""] = value.split("#");
  const [path = "", query = ""] = pathAndQuery.split("?");

  const trimmedPath = path.replace(/\/+$/, "");
  const nextPath = trimmedPath ? `${trimmedPath}/` : "/";

  return `${nextPath}${query ? `?${query}` : ""}${hash ? `#${hash}` : ""}`;
};

export const ensureTrailingSlashHref = (to) => {
  if (typeof to !== "string") return to;
  if (!to || isAbsoluteUrl(to)) return to;
  if (to.startsWith("#") || to.startsWith("?")) return to;

  return normalizePathWithTrailingSlash(to);
};
